import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Select,
  MenuItem,
  FormControl,
  SelectChangeEvent,
  Grid,
  Box,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import CommonHeader from "../components/CommonHeader";
import styles from "./QuestionnaireSp.module.css";

interface Option {
  label: string;
  value: string;
}

const QuestionnaireSp = () => {
  const navigate = useNavigate();
  const [selectedAgeSlbox, setSelectedAgeSlbox] = useState("");
  const [selectedPriceSlbox, setSelectedPriceSlbox] = useState("");
  const [selectedCometoNumberSlbox, setselectedCometoNumberSlbox] = useState("");
  const [selectedPurpose, setSelectedPurposeSlbox] = useState("");
  const [selectedWhereFrom, setSelectedWhereFromSlbox] = useState("");
  const [selectedWithWhom, setSelectedWithWhomSlbox] = useState("");
  const OPTIONS_AGE_BOX: Option[] = [
    { label: "10代以下", value: "0" },
    { label: "10代", value: "1" },
    { label: "20代", value: "2" },
    { label: "30代", value: "3" },
    { label: "40代", value: "4" },
    { label: "50代", value: "5" },
    { label: "60代以上", value: "6" },
  ];
  const OPTIONS_PRICE_BOX: Option[] = [
    { label: "100円以下", value: "0" },
    { label: "100円", value: "1" },
    { label: "200円", value: "2" },
    { label: "300円", value: "3" },
    { label: "400円", value: "4" },
    { label: "500円以上", value: "5" },
  ];
  const OPTIONS_COMETO_NUMBER_BOX: Option[] = [
    { label: "1回目", value: "0" },
    { label: "2回目", value: "1" },
    { label: "3回以上", value: "2" },
  ];
  const OPTIONS_PURPOSE_BOX: Option[] = [
    { label: "スキーヤー", value: "0" },
    { label: "スノーボーダー", value: "1" },
  ];
  const OPTIONS_WHERE_FROM_BOX: Option[] = [
    { label: "長野市内", value: "0" },
    { label: "その他 長野県内", value: "1" },
    { label: "その他 長野県外", value: "2" },
  ];
  const OPTIONS_WITH_WHOM_BOX: Option[] = [
    { label: "家族", value: "0" },
    { label: "友人", value: "1" },
    { label: "一人", value: "2" },
    { label: "その他", value: "3" },
  ];
  const handleChangeAgeSlbox = (event: SelectChangeEvent<string>) => {
    setSelectedAgeSlbox(event.target.value);
  };
  const handleChangePriceSlbox = (event: SelectChangeEvent<string>) => {
    setSelectedPriceSlbox(event.target.value);
  };
  const handleChangeComeNumberSlbox = (event: SelectChangeEvent<string>) => {
    setselectedCometoNumberSlbox(event.target.value);
  };
  const handleChangePurposeSlbox = (event: SelectChangeEvent<string>) => {
    setSelectedPurposeSlbox(event.target.value);
  };
  const handleChangeWhereFromSlbox = (event: SelectChangeEvent<string>) => {
    setSelectedWhereFromSlbox(event.target.value);
  };
  const handleChangeWithWhomSlbox = (event: SelectChangeEvent<string>) => {
    setSelectedWithWhomSlbox(event.target.value);
  }

  const theme = createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            backgroundColor: "#007bff",
            color: "#fff",
            fontSize: "1.0rem",
            minWidth: "30vw",
            marginBottom: "10vw",
            marginRight: "5vw",
            marginTop: "5vw",
            "&:hover": {
              backgroundColor: "#0056b3",
            },
          },
        },
      },
    },
  });
  const handleButtonClick = () => {
    if (selectedAgeSlbox && selectedPriceSlbox) {
      navigate("/dlimagesSp", {
        state: {
          answers: {
            ageSl: selectedAgeSlbox,
            priceSl: selectedPriceSlbox,
            cometoSl: selectedCometoNumberSlbox,
            purposeSl: selectedPurpose,
            wherefromSl: selectedWhereFrom,
            isAnswerd: true,
          },
        },
      });
    } else {
      alert("アンケート回答をお願いします");
    }
  };

  return (
    <>
      <CommonHeader />
      <main className={styles.main}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            marginLeft: "1rem",
            marginRight: "1rem",
          }}
        >
          <div>
            <h3>
              年代を選んでください <span style={{ color: "red" }}>*</span>
            </h3>
            <FormControl sx={{ m: 1, minWidth: "40vw" }}>
              <Select
                labelId="select-label-age"
                id="select-age"
                value={selectedAgeSlbox}
                onChange={handleChangeAgeSlbox}
                sx={{ fontSize: "1rem" }}
              >
                <MenuItem value="" sx={{ fontSize: "1rem" }}>
                  <em>未選択</em>
                </MenuItem>
                {OPTIONS_AGE_BOX.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{ fontSize: "1rem" }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <h3>
              購入したいと思う1枚あたりの値段について選んでください{" "}
              <span style={{ color: "red" }}>*</span>
            </h3>
            <FormControl sx={{ m: 1, minWidth: "40vw" }}>
              <Select
                labelId="select-label-price"
                id="select-price"
                value={selectedPriceSlbox}
                onChange={handleChangePriceSlbox}
                sx={{ fontSize: "1rem" }}
              >
                <MenuItem value="" sx={{ fontSize: "1rem" }}>
                  <em>未選択</em>
                </MenuItem>
                {OPTIONS_PRICE_BOX.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{ fontSize: "1rem" }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <h3>今シーズンの来場は何回目になりますか</h3>
            <FormControl sx={{ m: 1, minWidth: "40vw" }}>
              <Select
                labelId="select-label-number"
                id="select-number"
                value={selectedCometoNumberSlbox}
                onChange={handleChangeComeNumberSlbox}
                sx={{ fontSize: "1rem" }}
              >
                <MenuItem value="" sx={{ fontSize: "1rem" }}>
                  <em>未選択</em>
                </MenuItem>
                {OPTIONS_COMETO_NUMBER_BOX.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{ fontSize: "1rem" }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <h3>スキーヤー / スノーボーダーを選択</h3>
            <FormControl sx={{ m: 1, minWidth: "40vw" }}>
              <Select
                labelId="select-label-number"
                id="select-number"
                value={selectedPurpose}
                onChange={handleChangePurposeSlbox}
                sx={{ fontSize: "1rem" }}
              >
                <MenuItem value="" sx={{ fontSize: "1rem" }}>
                  <em>未選択</em>
                </MenuItem>
                {OPTIONS_PURPOSE_BOX.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{ fontSize: "1rem" }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <h3>どこからお越しになりましたか</h3>
            <FormControl sx={{ m: 1, minWidth: "40vw" }}>
              <Select
                labelId="select-label-number"
                id="select-number"
                value={selectedWhereFrom}
                onChange={handleChangeWhereFromSlbox}
                sx={{ fontSize: "1rem" }}
              >
                <MenuItem value="" sx={{ fontSize: "1rem" }}>
                  <em>未選択</em>
                </MenuItem>
                {OPTIONS_WHERE_FROM_BOX.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{ fontSize: "1rem" }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <h3>どなたとお越しになりましたか</h3>
            <FormControl sx={{ m: 1, minWidth: "40vw" }}>
              <Select
                labelId="select-label-number"
                id="select-number"
                value={selectedWithWhom}
                onChange={handleChangeWithWhomSlbox}
                sx={{ fontSize: "1rem" }}
              >
                <MenuItem value="" sx={{ fontSize: "1rem" }}>
                  <em>未選択</em>
                </MenuItem>
                {OPTIONS_WITH_WHOM_BOX.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{ fontSize: "1rem" }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Grid justifyContent="end" container>
              <Grid item>
                <ThemeProvider theme={theme}>
                  <Button onClick={handleButtonClick}>つぎへ</Button>
                </ThemeProvider>
              </Grid>
            </Grid>
          </div>
        </Box>
      </main>
    </>
  );
};

export default QuestionnaireSp;
